interface DocumentTitleProps { title: string }

const DocumentTitle = (props: DocumentTitleProps) => {
    document.title = props.title || 'Progress elections'
    return null;
}

export { DocumentTitle };
